import React from "react";

import { PageBuilderBlogMosaicFragment } from "types/graphql-types";
import {
  MosaicLayout,
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import { graphql } from "gatsby";
import BlogCard from "components/BlogCard/BlogCard";
import InlineCTABox, {
  InlineCTABoxButton,
  InlineCTABoxContent
} from "components/InlineCTABox/InlineCTABox";
import { BackgroundColor } from "types/componentBackground";
import PageBuilderButtonCTA from "components/PageBuilder/PageBuilderButtonCTA";
import { dequal } from "dequal/lite";
import { cardColorForBackground } from "./pageBuilderRenderHelper";

export type PageBuilderBlogMosaicProps = PageBuilderBlogMosaicFragment & {
  backgroundColor?: BackgroundColor;
  cardBackgroundColor?: BackgroundColor;
};

const PageBuilderBlogMosaic: React.FC<
  React.PropsWithChildren<PageBuilderBlogMosaicProps>
> = ({ content, backgroundColor, cardBackgroundColor }) => {
  const _cardBackgroundColor = backgroundColor
    ? cardColorForBackground(backgroundColor)
    : cardBackgroundColor;
  return (
    <React.Fragment>
      <SectionTitle variant="wide">
        <SectionTitleHeading>
          {content?.intro?.title?.localized}
        </SectionTitleHeading>
        <SectionTitleBody>{content?.intro?.text?.localized}</SectionTitleBody>
      </SectionTitle>
      <MosaicLayout variant="column2" data-content-name="blog_posts_mosaic">
        {content?.blogPosts?.map((blogPost) => {
          return (
            <BlogCard
              key={blogPost.id}
              linkText={blogPost.linkText}
              backgroundColor={_cardBackgroundColor}
              {...blogPost}
            />
          );
        })}
      </MosaicLayout>
      {content?.linkText?.localized && (
        <InlineCTABox
          align="center"
          spacingTop={"regular"}
          dataContentName="more_container"
        >
          <InlineCTABoxContent>
            {content?.linkText?.localized}
          </InlineCTABoxContent>
          {content?.ctaButtons && content.ctaButtons.length > 0 && (
            <InlineCTABoxButton>
              <PageBuilderButtonCTA {...content.ctaButtons[0]} />
            </InlineCTABoxButton>
          )}
        </InlineCTABox>
      )}
    </React.Fragment>
  );
};

export default React.memo(PageBuilderBlogMosaic, dequal);

export const fragments = graphql`
  fragment PageBuilderBlogMosaic on SanityBlogMosaic {
    _key
    content {
      ...PageBuilderBlogSection
    }
  }

  fragment PageBuilderBlogSection on SanityBlogSection {
    blogPosts
    intro {
      text {
        localized
      }
      title {
        localized
      }
    }
    linkText {
      localized
    }
    ctaButtons {
      ...ButtonCTA
    }
  }
`;
